import { render, staticRenderFns } from "./DocumentHistory.vue?vue&type=template&id=590d4776&scoped=true&"
import script from "./DocumentHistory.vue?vue&type=script&lang=js&"
export * from "./DocumentHistory.vue?vue&type=script&lang=js&"
import style0 from "./DocumentHistory.vue?vue&type=style&index=0&lang=css&"
import style1 from "./DocumentHistory.vue?vue&type=style&index=1&id=590d4776&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590d4776",
  null
  
)

export default component.exports